import { Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
  templateUrl: './equipment-main.component.html',
  styleUrls: ['./equipment-main.component.scss']
})
export class EquipmentMainComponent implements OnInit, OnDestroy{

  public activeId: string = 'telephony';
  private subscriptions: Subscription[] = [];

  constructor(private router: Router){}

  ngOnInit(): void {
    const splits = this.router.url.split('/');
    this.activeId = splits.find((v: string) => v === 'telephony' || v === 'connectivity');
    this.subscriptions.push(
      this.router.events.subscribe((event) => {
        if(event instanceof NavigationEnd){
          const path = event.url.split('/')
          this.activeId = path.find((v: string) => v === 'telephony' || v === 'connectivity');
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }
}